import React from "react";
import styles from "./ProductReviewClient.module.css";
import Avatar from "@mui/material/Avatar";
import Rating from "@mui/material/Rating";

const ProductReviewClient = ({ name, para, image, rate, time }) => {
  return (
    <div className={styles.productReview}>
      <div className={styles.detail}>
        <Avatar alt="profile" src={image} />
        <span className={styles.reviewer}>{name}</span>
        <div className={styles.time}>.{time}</div>
        <div className={styles.ratingWrap}>
          <Rating readOnly={true} value={rate} size="small" />
          <div className={styles.rate}>{rate}</div>
        </div>
      </div>
      <div className={styles.para}>{para}</div>
    </div>
  );
};

export default ProductReviewClient;
